import { render, staticRenderFns } from "./dealt.vue?vue&type=template&id=3cc7202a&scoped=true"
import script from "./dealt.vue?vue&type=script&lang=js"
export * from "./dealt.vue?vue&type=script&lang=js"
import style0 from "./dealt.vue?vue&type=style&index=0&id=3cc7202a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7202a",
  null
  
)

export default component.exports